import React from 'react';

import { DoneAdornmentForAutoSuggestProps } from './DoneAdornmentForAutoSuggest.interface';
import { useStyles } from './DoneAdornmentForAutoSuggest.styles';
import { DoneAdornment } from 'app/components/DoneAdornment';

export default function DoneAdornmentForAutoSuggest(
  props: DoneAdornmentForAutoSuggestProps
) {
  const classes = useStyles();

  return <DoneAdornment className={classes.root} />;
}
